<template>
  <v-dialog v-model="dialog" :overlay="false" scrollable max-width="600px">
    <v-card tile flat>
      <v-app-bar flat dark color="primary">
        <v-app-bar-nav-icon><v-icon>far fa-alarm-clock</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>Pending Enquiry</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card flat tile class="ma-0 mb-0">
        <v-card-text>
          <v-form lazy-validation>
            <v-container fluid grid-list-md>
              <v-layout v-if="!showAcceptConfirmation && !showRejectConfirmation">
                <v-btn color="primary" @click="showRejectConfirmation = true">Reject Enquiry</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="showAcceptConfirmation = true">Accept Enquiry</v-btn>
              </v-layout>
              <v-layout v-if="showAcceptConfirmation">
                <v-flex xs12>
                  <v-card-text>
                    <p class="font-weight-bold">
                      You are not permitted to complete a Credit Report check on an SME User (including their business
                      and its directors or owners) without the SME User's prior explicit consent.
                    </p>
                    <p>
                      ABF has provided you with anonymous information about the SME User including a Credit Report
                      (where possible) and the Data entered on the Platform by the SME User.
                    </p>
                    <p>
                      This information should be used by you to determine whether to accept or reject this opportunity.
                    </p>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" text @click.native="showAcceptConfirmation = false">Cancel</v-btn>
                    <v-btn color="success" @click="save('ENQUIRY ACCEPTED')">Agree &amp; continue</v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
              <v-layout v-if="showRejectConfirmation">
                <v-flex xs12>
                  <v-card-title>
                    <h3 class="font-weight-bold">Are you sure you want to reject this enquiry?</h3>
                  </v-card-title>
                  <v-card-text>
                    <v-textarea box label="Reason for rejection" v-model="rejectionReason"></v-textarea>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" text @click.native="showRejectConfirmation = false">Cancel</v-btn>
                    <v-btn color="success" @click="save('ENQUIRY REJECTED')">Reject Enquiry</v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'enquiry-pending-dialog',
  props: ['show', 'enquiry'],
  data: () => ({
    showRejectConfirmation: false,
    showAcceptConfirmation: false,
    rejectionReason: null
  }),
  computed: {
    ...mapGetters(['EnquiryStatuses']),
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    }
  },
  methods: {
    ...mapActions(['addNotification', 'postCustomerComment', 'selectCustomer', 'storeFunderEnquiry']),
    closeDialog() {
      this.dialog = false;
    },
    async save(statusName) {
      const enquiryStatus = _.find(this.EnquiryStatuses, ['name', statusName]);

      if (this.rejectionReason) {
        await this.postCustomerComment({
          comment: this.rejectionReason,
          privacy: 'public',
          commentParams: { id: this.enquiry.id, type: 'enquiry' }
        });
      }

      await this.storeFunderEnquiry({
        id: this.enquiry.id,
        updates: {
          enquiry_status_id: enquiryStatus.id
        }
      });

      this.selectCustomer(this.enquiry.customer.id);
      this.addNotification({ text: `enquiry updated` });
      this.dialog = false;
      this.rejectionReason = null;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  div.list__tile,
  .subheader {
    padding: 0 16px 0 0;
  }

  input,
  label {
    font-size: 14px;
  }
}

address {
  font-style: normal;
}
</style>
